module.exports = __webpack_public_path__ + "img/icon_box_1_1.cfffd0d2.png";